import { FilterName } from '../../../__generated__/fed-graphql-types'

import { OptionValue } from '../../../utils/search/search-results-util/search-results.util'

import { ParsedQuery } from 'query-string'
import { FilterQueryParam } from './query-params'
import { Channel } from '@at/sauron-platform-core'

export type FilterValueToQueryParam = { [key: string]: [string, OptionValue] }

export type FilterQueryParamOverrides = Partial<Record<FilterName, FilterQueryParamOverride>>

export type FilterQueryParamOverride = string | FilterValueToQueryParam

export const queryParamToFiltersOverrides: FilterQueryParamOverrides = {
    [FilterName.distance]: FilterQueryParam.radius,
    [FilterName.min_price]: FilterQueryParam.price_from,
    [FilterName.max_price]: FilterQueryParam.price_to,
    [FilterName.min_monthly_price]: FilterQueryParam.min_monthly_price,
    [FilterName.max_monthly_price]: FilterQueryParam.max_monthly_price,
    // [FilterName.price_search_type]: {
    //     monthly: ['price-search-type', 'monthly-price'],
    //     total: ['price-search-type', 'total-price'],
    // },
    [FilterName.yearly_mileage]: FilterQueryParam.yearly_mileage,
    [FilterName.with_manufacturer_rrp_saving]: {
        true: [FilterQueryParam.new_car_has_deal, 'on'],
    },
    [FilterName.min_year_manufactured]: FilterQueryParam.year_from,
    [FilterName.max_year_manufactured]: FilterQueryParam.year_to,
    [FilterName.max_mileage]: FilterQueryParam.maximum_mileage,
    [FilterName.min_mileage]: FilterQueryParam.minimum_mileage,
    [FilterName.fuel_type]: FilterQueryParam.fuel_type,
    [FilterName.body_type]: FilterQueryParam.body_type,
    [FilterName.min_engine_size]: FilterQueryParam.minimum_badge_engine_size,
    [FilterName.max_engine_size]: FilterQueryParam.maximum_badge_engine_size,
    [FilterName.min_engine_size_cc]: FilterQueryParam.cc_from,
    [FilterName.max_engine_size_cc]: FilterQueryParam.cc_to,
    [FilterName.cab_type]: FilterQueryParam.cab_type,
    [FilterName.seller_type]: FilterQueryParam.seller_type,
    [FilterName.doors_values]: FilterQueryParam.quantity_of_doors,
    [FilterName.is_writeoff]: {
        exclude: [FilterQueryParam.exclude_writeoff_categories, 'on'],
        only: [FilterQueryParam.only_writeoff_categories, 'on'],
    },
    [FilterName.min_seats]: FilterQueryParam.minimum_seats,
    [FilterName.max_seats]: FilterQueryParam.maximum_seats,
    [FilterName.acceleration_values]: FilterQueryParam.zero_to_60,
    [FilterName.annual_tax_values]: FilterQueryParam.annual_tax_cars,
    [FilterName.end_layout]: FilterQueryParam.end_layout,
    [FilterName.bedroom_layout]: FilterQueryParam.bedroom_layout,
    [FilterName.driver_position]: FilterQueryParam.driver_position,
    [FilterName.style]: FilterQueryParam.category,
    [FilterName.sub_style]: FilterQueryParam.sub_category,
    [FilterName.axle_config]: FilterQueryParam.axle_config,
    [FilterName.min_gross_vehicle_weight]: FilterQueryParam.min_gross_vehicle_weight,
    [FilterName.max_gross_vehicle_weight]: FilterQueryParam.max_gross_vehicle_weight,
    [FilterName.min_gross_trailer_weight]: FilterQueryParam.min_gross_trailer_weight,
    [FilterName.max_gross_trailer_weight]: FilterQueryParam.max_gross_trailer_weight,
    [FilterName.min_hours_used]: FilterQueryParam.min_hours_used,
    [FilterName.max_hours_used]: FilterQueryParam.max_hours_used,
    [FilterName.min_engine_power]: FilterQueryParam.min_engine_power,
    [FilterName.max_engine_power]: FilterQueryParam.max_engine_power,
    [FilterName.emission_class]: FilterQueryParam.emission_class,
    [FilterName.min_mtplm]: FilterQueryParam.min_mtplm,
    [FilterName.max_mtplm]: FilterQueryParam.max_mtplm,
    [FilterName.min_exterior_length]: FilterQueryParam.min_exterior_length,
    [FilterName.max_exterior_length]: FilterQueryParam.max_exterior_length,
    [FilterName.is_seller_defined_used]: FilterQueryParam.is_seller_defined_used,
    [FilterName.fuel_consumption_values]: FilterQueryParam.fuel_consumption,
    [FilterName.co2_emission_values]: FilterQueryParam.co2_emissions,
    [FilterName.battery_range_values]: FilterQueryParam.battery_range,
    [FilterName.battery_charge_time_values]: FilterQueryParam.battery_time,
    [FilterName.battery_quick_charge_time_values]: FilterQueryParam.battery_quick_time,
    [FilterName.drivetrain]: FilterQueryParam.drivetrain,
    [FilterName.boot_size_values]: FilterQueryParam.boot_size_values,
    [FilterName.ni_only]: {
        on: [FilterQueryParam.ni_only, 'on'],
    },
    [FilterName.is_manufacturer_approved]: {
        true: [FilterQueryParam.ma, 'Y'],
    },
    [FilterName.lat_long]: FilterQueryParam.lat_long,
    [FilterName.ulez_compliant]: FilterQueryParam.ulez_compliant,
    [FilterName.part_exchange_available]: {
        on: [FilterQueryParam.part_ex_available, 'on'],
    },
    [FilterName.home_delivery_adverts]: {
        only: [FilterQueryParam.only_delivery_option, 'on'],
        include: [FilterQueryParam.include_delivery_option, 'on'],
    },
    [FilterName.insurance_group]: FilterQueryParam.insurance_group,
    [FilterName.aggregated_trim]: FilterQueryParam.aggregated_trim,
    [FilterName.modified_customer]: FilterQueryParam.modified_customer,
    [FilterName.with_digital_retailing]: FilterQueryParam.with_digital_retailing,
    [FilterName.vat_status]: FilterQueryParam.vat_status,
    [FilterName.retailer_id]: FilterQueryParam.dealer,
    [FilterName.advert_id]: FilterQueryParam.advert_id,
    [FilterName.lease_product_type]: FilterQueryParam.lease_product_type,
    [FilterName.lease_in_stock]: FilterQueryParam.lease_in_stock,
    [FilterName.min_lease_monthly_price]: FilterQueryParam.min_lease_monthly_price,
    [FilterName.max_lease_monthly_price]: FilterQueryParam.max_lease_monthly_price,
    [FilterName.min_lease_monthly_price_ex_vat]: FilterQueryParam.min_lease_monthly_price_ex_vat,
    [FilterName.max_lease_monthly_price_ex_vat]: FilterQueryParam.max_lease_monthly_price_ex_vat,
    [FilterName.category_tag]: FilterQueryParam.category_tag,
}

export const filterToQueryParamOverrides = {
    ...queryParamToFiltersOverrides,
    [FilterName.style]: FilterQueryParam.style,
    [FilterName.sub_style]: FilterQueryParam.sub_style,
}

export const carFilterToQueryParamOverrides = {
    ...filterToQueryParamOverrides,
    [FilterName.co2_emission_values]: FilterQueryParam.co2_emissions_cars,
}

export const carQueryParamToFiltersOverrides = {
    ...queryParamToFiltersOverrides,
    [FilterName.co2_emission_values]: FilterQueryParam.co2_emissions_cars,
}

export const vanFilterToQueryParamOverrides = {
    ...filterToQueryParamOverrides,
    [FilterName.min_price]: FilterQueryParam.supplied_price_from,
    [FilterName.max_price]: FilterQueryParam.supplied_price_to,
}

export const vanQueryParamToFiltersOverrides = {
    ...queryParamToFiltersOverrides,
    [FilterName.min_price]: FilterQueryParam.supplied_price_from,
    [FilterName.max_price]: FilterQueryParam.supplied_price_to,
}

export const getQueryParamToFiltersOverrides = (channel: Channel) => {
    switch (channel) {
        case Channel.cars:
            return carQueryParamToFiltersOverrides
        case Channel.vans:
            return vanQueryParamToFiltersOverrides
        default:
            return queryParamToFiltersOverrides
    }
}

export const getFilterToQueryParamOverrides = (channel: Channel) => {
    switch (channel) {
        case Channel.cars:
            return carFilterToQueryParamOverrides
        case Channel.vans:
            return vanFilterToQueryParamOverrides
        default:
            return filterToQueryParamOverrides
    }
}

export const getQueryParamFromFacetValue = (
    facetValueToQueryParam: FilterValueToQueryParam,
    optionValues: OptionValue[] | [undefined]
) => {
    const facetValueToQueryParamEntries = Object.entries(facetValueToQueryParam)
    const valueWithQueryParam = facetValueToQueryParamEntries.find(([facetValue]) => {
        return facetValue === String(optionValues[0])
    })

    if (valueWithQueryParam) {
        const [, [key, value]] = valueWithQueryParam
        return { [key]: value }
    }

    return {}
}

// TODO: This should be an immutable pure function.
export const removeOtherSearchFilterValueQueryParams = (
    filterValueToQueryParam: FilterValueToQueryParam,
    parsedSearch: ParsedQuery
) => {
    Object.values(filterValueToQueryParam).forEach(([key]) => {
        if (parsedSearch[key]) {
            delete parsedSearch[key]
        }
    })
}

export const getFilterAndValueFromQueryParam = (
    queryParamKey: string,
    queryParamValue: string | string[],
    channel: Channel
) => {
    return Object.entries(getQueryParamToFiltersOverrides(channel))
        .filter(([, facetValueToQueryParam]) => typeof facetValueToQueryParam !== 'string')
        .reduce<[FilterName, string] | []>(
            (filterNameAndValue, [filterName, filterValueToQueryParam]): [FilterName, string] | [] => {
                if (filterNameAndValue && filterNameAndValue.length) {
                    return filterNameAndValue
                }

                const queryParamValues = Array.isArray(queryParamValue) ? queryParamValue : [queryParamValue]

                const facetValueToQueryParamEntries = Object.entries(filterValueToQueryParam as FilterValueToQueryParam)

                const valueWithQueryParam = facetValueToQueryParamEntries.find(([, [key, value]]) =>
                    queryParamValues.find((paramValue: string) => queryParamKey === key && paramValue === value)
                )

                if (valueWithQueryParam) {
                    const [value] = valueWithQueryParam

                    return [filterName as FilterName, value]
                }

                return []
            },
            []
        )
}

export const DeprecatedQueryParamMapping = {
    'sub-category': 'sub-style',
    category: 'style',
    maxPrice: 'price-to',
    minPrice: 'price-from',
}

/**
 * Return the query parameters with any deprecated parameter removed providing the parameter which replaced the deprecated one is also present.
 * E.g. Given {category: 'BLAH', style:'BLAH BLAH'}, this function will return {style:'BLAH BLAH'}
 */
export const removeDeprecatedDuplicateParams = (queryParams: ParsedQuery<string>): ParsedQuery<string> => {
    const cleanedQueryParams = { ...queryParams }

    Object.entries(DeprecatedQueryParamMapping).forEach(([key, value]) => {
        if (cleanedQueryParams[key] && cleanedQueryParams[value]) {
            delete cleanedQueryParams[key]
        }
    })

    return cleanedQueryParams
}
